import React, { useEffect } from 'react';
import { setPageMeta } from '../lib/seo';

function NotFound() {
  useEffect(() => {
    setPageMeta({
      title: 'Page Not Found — Elorimi',
      description: 'The page you are looking for could not be found.',
    });
  }, []);

  return (
    <div className="not-found-page">
      {/* Optimized Animated Background */}
      <div className="bg-animation">
        <div className="bg-mesh"></div>
        <div className="bg-grid"></div>
        <div className="bg-glow bg-glow-1"></div>
        <div className="bg-glow bg-glow-2"></div>
        <div className="bg-glow bg-glow-3"></div>
      </div>

      {/* Main Content */}
      <div className="not-found-content container">
        <div className="row align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
          <div className="col-lg-8 text-center">
           
            <h1 className="not-found-title" style={{ 
              fontSize: '6rem', 
              fontWeight: '700', 
              marginBottom: '1rem',
              background: 'linear-gradient(135deg, #9FF13E 0%, #0891b2 50%, #7c3aed 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              lineHeight: '1'
            }}>
              404
            </h1>
            
            <h2 className="not-found-subtitle" style={{
              fontSize: '2rem',
              fontWeight: '600',
              color: '#ffffff',
              marginBottom: '1.5rem'
            }}>
              Oops! Page Not Found
            </h2>
            
            <p className="not-found-description" style={{
              fontSize: '1.2rem',
              color: '#a3b3c1',
              marginBottom: '2rem',
              maxWidth: '600px',
              margin: '0 auto 2rem'
            }}>
              The page you're looking for doesn't exist or has been moved. Don't worry, our powerful GPUs are still here to serve you!
            </p>
            
            <div className="not-found-actions" style={{ display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
              <a href="/" className="btn btn-primary btn-lg" style={{ minWidth: '200px' }}>
                Go Home
              </a>
            </div>
            
           
   
          </div>
        </div>
      </div>

      <style jsx>{`
       

        .not-found-page {
          position: relative;
          min-height: 100vh;
          
          overflow: hidden;
        }

        .not-found-content {
          position: relative;
          display: flex; 
          height: 600px;
            margin: auto;
            justify-content: center;
          z-index: 2;
          padding: 2rem 1rem;
        }

       

      
        .not-found-title {
          margin-bottom: 1rem;
          font-weight: 800;
        }

       
        .not-found-description {
          font-size: 1.1rem;
          color: #a3b3c1;
          margin: 0 auto 2rem;
          max-width: 600px;
        }

        .not-found-actions {
          display: flex;
          justify-content: center;
          gap: 1rem;
          flex-wrap: wrap;
          margin-bottom: 3rem;
        }

        .btn {
          min-width: 180px;
          padding: 0.75rem 1.5rem;
          border-radius: 8px;
          text-decoration: none;
          display: inline-block;
          text-align: center;
          font-weight: 500;
          transition: all 0.3s ease;
          border: none;
          cursor: pointer;
          font-size: 1rem;
        }

        .btn-primary {
          background: linear-gradient(135deg, #9FF13E 0%, #0891b2 50%, #7c3aed 100%);
          color: #000;
          box-shadow: 0 4px 20px rgba(159, 241, 62, 0.3);
        }

        .btn-primary:hover {
          
          box-shadow: 0 6px 25px rgba(159, 241, 62, 0.4);
        }

      

        @media (max-width: 768px) {
          .not-found-title {
            font-size: 4rem;
          }

          
          .not-found-description {
            font-size: 1rem;
          }
          
          .not-found-actions {
            flex-direction: column;
            align-items: center;
          }
          
          .btn {
            width: 100%;
            max-width: 300px;
            margin-bottom: 0.5rem;
          }
          
     
        }
      `}</style>
    </div>
  );
}

export default NotFound;
